import { createContext } from 'react'

import { DeviceInfo } from '../../hooks/useDeviceInfo'

export interface DeviceInfoContextState {
  deviceInfo: DeviceInfo
}

const DeviceInfoContext = createContext<DeviceInfoContextState>({
  deviceInfo: {
    // @i18n-ignore
    deviceType: 'DESKTOP',
    isNativeView: false,
    isTablet: false,
  },
})

// @i18n-ignore
const DEVICE_INFO_CONTEXT_DISPLAY_NAME = 'Device Info Context'
DeviceInfoContext.displayName = DEVICE_INFO_CONTEXT_DISPLAY_NAME

export default DeviceInfoContext
